import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
})

function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token }
}

/** Fallback if API is unreachable (matches DB seed). */
const FALLBACK = [
  { name: 'Jie', email: 'jie@chibitronics.com' },
  { name: 'Laurie', email: 'laurie@chibitronics.com' },
  { name: 'Molly', email: 'molly@chibitronics.com' },
  { name: 'Jon', email: 'jon@chibitronics.com' },
  { name: 'Jenny', email: 'jenny@chibitronics.com' }
]

let cache = null
let inflight = null

export default {
  async list() {
    if (cache) return cache
    if (inflight) return inflight

    inflight = apiClient
      .get('/chibi_team', { headers: authHeaders() })
      .then(({ data }) => {
        const members = (data.members || []).map((m) => ({
          name: m.name,
          email: (m.email || '').toLowerCase()
        }))
        cache = members.length ? members : FALLBACK
        return cache
      })
      .catch(() => {
        cache = FALLBACK
        return cache
      })
      .finally(() => {
        inflight = null
      })

    return inflight
  },

  namesFrom(members) {
    return (members || []).map((m) => m.name)
  },

  clearCache() {
    cache = null
  }
}
